module.exports = __webpack_public_path__ + "static/media/tacometro-bajo-grande.78ee34d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro-bajo-grande.svg
// module id = 158
// module chunks = 0